(() => {
  // Cart hotfix: clamp qty to 1 and dedupe duplicate add calls.
  // Target: Willy Chavarria PDP add-to-cart double-add + inventory-as-qty regression.

  const originalFetch = window.fetch;

  const DEDUPE_WINDOW_MS = 900;
  let lastAdd = { sig: null, t: 0 };

  const isAddEndpoint = (url) =>
    typeof url === 'string' &&
    (url.includes('/cart/add') || url.includes('/cart/add.js'));

  const extractVariantId = (body) => {
    try {
      if (!body) return null;

      if (body instanceof FormData) {
        return body.get('id') || body.get('variant_id');
      }

      if (typeof body === 'string') {
        const t = body.trim();
        if (t.startsWith('{')) {
          const obj = JSON.parse(t);
          return obj?.id || obj?.variant_id || null;
        }
        const p = new URLSearchParams(t);
        return p.get('id') || p.get('variant_id');
      }
    } catch (_) {}

    return null;
  };

  const clampQtyToOne = (body) => {
    try {
      if (!body) return body;

      // FormData
      if (body instanceof FormData) {
        body.set('quantity', '1');
        return body;
      }

      // JSON body
      if (typeof body === 'string' && body.trim().startsWith('{')) {
        const obj = JSON.parse(body);
        if (obj && typeof obj === 'object') obj.quantity = 1;
        return JSON.stringify(obj);
      }

      // URL encoded
      if (typeof body === 'string') {
        const p = new URLSearchParams(body);
        p.set('quantity', '1');
        return p.toString();
      }
    } catch (_) {}

    return body;
  };

  const shouldBlockDuplicateAdd = (url, variantId) => {
    const now = Date.now();
    const sig = `${url}|${variantId || 'unknown'}`;

    if (lastAdd.sig === sig && (now - lastAdd.t) < DEDUPE_WINDOW_MS) return true;

    lastAdd = { sig, t: now };
    return false;
  };

  window.fetch = function(input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url;

    if (isAddEndpoint(url)) {
      const variantId = extractVariantId(init?.body);

      // 1) dedupe identical add calls
      if (shouldBlockDuplicateAdd(url, variantId)) {
        return Promise.resolve(
          new Response(JSON.stringify({ blocked_duplicate_add: true }), {
            status: 200,
            headers: { 'Content-Type': 'application/json' },
          })
        );
      }

      // 2) clamp qty to 1
      init.body = clampQtyToOne(init.body);
    }

    return originalFetch.call(this, input, init);
  };
})();
